import { render, staticRenderFns } from "./weChat.vue?vue&type=template&id=54d2dae2&scoped=true&"
import script from "./weChat.vue?vue&type=script&lang=js&"
export * from "./weChat.vue?vue&type=script&lang=js&"
import style0 from "./weChat.vue?vue&type=style&index=0&id=54d2dae2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.7.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d2dae2",
  null
  
)

export default component.exports